import { render, staticRenderFns } from "./TemplateDetailsCustomisation.vue?vue&type=template&id=70ddf4b2&"
import script from "./TemplateDetailsCustomisation.vue?vue&type=script&lang=ts&"
export * from "./TemplateDetailsCustomisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports